// jQuery(".tab-wrapper .tab").click(function() {
// 	jQuery(".tab-wrapper .tab").removeClass("active").eq(jQuery(this).index()).addClass("active");
// 	jQuery(".tab_item").removeClass("active").eq(jQuery(this).index()).addClass("active")
// }).eq(0).addClass("active");

jQuery(function() {
  jQuery('.tabs-nav a').click(function() {

    // Check for active
    jQuery('.tabs-nav li').removeClass('active');
    jQuery(this).parent().addClass('active');

    // Display active tab
    const currentTab = jQuery(this).attr('href');
		const displayProp = jQuery(currentTab).data('display') || 'block';
    jQuery(currentTab).siblings().hide();
    jQuery(currentTab).css('display', displayProp);

    return false;
  });
});
